module.exports = __webpack_public_path__ + "55a701cfeba952f179048061f5c85467.jpg";